import infoDept from './dept';
import userManagement from './userManagement';

export default {
    infoDept,
    userManagement,
};
